import { splitAccessorPath } from '../../../core/utils/accessors/split-accessor-path.js';

export function getAccessor(s?: string) {
  if (!s) {
    return undefined;
  }
  return /[[.]/.test(s) ? splitAccessorPath(s) : [s];
}
